import { Fragment, Node } from 'prosemirror-model';

interface NodeOfTypeForRangeProps {
  node: Node;
  type: string;
  from: number;
  to: number;
  allowNested?: boolean;
}

interface NodeOfTypeForRangeResult {
  pos: number;
  content: Fragment;
  nodeSize: number;
}

/**
 * find all nodes of a certain type in a range, also returns on a partial overlap
 */
export function getNodesOfTypeForRange({
  node,
  type,
  from,
  to,
  allowNested = false,
}: NodeOfTypeForRangeProps): NodeOfTypeForRangeResult[] {
  const foundNodes: NodeOfTypeForRangeResult[] = [];

  node.nodesBetween(from, to, (node, pos) => {
    if (node.type.name === type) {
      foundNodes.push({
        pos,
        content: node.content,
        nodeSize: node.nodeSize,
      });
      return allowNested;
    }

    return true;
  });

  return foundNodes;
}
